import React from 'react'
import style from './style.module.scss'
export const Preloader = () => {
  return (
    <div className={style.wrapper}>
        Lorem ipsum dolor sit, amet consectetur adipisicing elit. Vitae quam minus suscipit enim architecto odio veritatis nisi expedita repudiandae reiciendis neque, quod quos similique. Provident quibusdam molestiae sed ipsum id.
    </div>
  )
}
